import React from "react";
import styles from "./EmptyState.module.css";
import { CustomButtonLink, icon } from "../../../../common/components";
import { translate } from "../../../../common/providers";
import { useSelector } from "react-redux";
import { SEARCH_TABS } from "../../constants/tabs";

const EmptyState = ({ deliverablesDoNotExist = false, noFilters = false }) => {
  const companyId = useSelector(({ context }) => context.company?.id);
  const domain = useSelector(({ context }) => context.domain);
  const selectedSearchTab = useSelector(({ multiProjectSearch }) => multiProjectSearch.selectedSearchTab);
  const handleGetHeader = () => {
    if (deliverablesDoNotExist && selectedSearchTab === SEARCH_TABS.DELIVERABLE) {
      return translate("multi-projects-search.identified-contents.saved.empty-state.deliverable.header");
    }
    if (noFilters) {
      return translate("multi-projects-search.identified-contents.saved.empty-state.no-filter");
    }
    return translate("common:empty-state.no-results");
  };
  const handleGetBodyText = () => {
    if (deliverablesDoNotExist) {
      return translate("multi-projects-search.identified-contents.saved.empty-state.deliverable.body");
    }
    if (noFilters) {
      return "";
    }
    return translate("multi-projects-search.identified-contents.saved.empty-state.body");
  };
  return (
    <div className={styles.container}>
      <div className={styles.header}>{handleGetHeader()}</div>
      {selectedSearchTab === SEARCH_TABS.DELIVERABLE && (
        <>
          <div className={styles.body}>
            {handleGetBodyText()}
            <div className={styles.linkContainer}>
              {deliverablesDoNotExist && (
                <CustomButtonLink external openInNewTab size="sm" to="https://academy.aitenders.com/">
                  {translate("common:btn.access-tutorial")}
                </CustomButtonLink>
              )}
            </div>
          </div>

          {deliverablesDoNotExist && (
            <div>
              <CustomButtonLink
                external
                openInNewTab
                startIcon={icon.faArrowUpRightFromSquare}
                to={`https://${domain}?companyId=${companyId}`}
                variant="contained"
              >
                {translate("multi-projects-search.identified-contents.saved.empty-state.deliverable.access-document")}
              </CustomButtonLink>
            </div>
          )}
        </>
      )}
    </div>
  );
};

export default EmptyState;
